const MARKET_ERROR_MESSAGES: Record<string, string> = {
  invalid_size: 'Failed to create product: invalid size'
}

const PARAM_ERROR_CATEGORIES = ['PARAM_MISSING', 'PARAM_WRONG_FORMAT']

export const readableMarketErrors = (marketErrors: any): { error: string[] } | null => {
  const errors = marketErrors?.longMessage?.errors
  if (!Array.isArray(errors)) return null

  return { error: errors.map(e => MARKET_ERROR_MESSAGES[e?.code] ?? e?.message).filter(Boolean) }
}

const longMessageLabel = (raw: any): string => {
  if (raw == null) return ''
  if (Array.isArray(raw)) return raw.join(', ')
  if (typeof raw !== 'object') return String(raw)

  const readable = readableMarketErrors({ longMessage: raw })
  return readable ? readable.error.join(' — ') : JSON.stringify(raw)
}

export const marketErrorLabel = (marketErrors: any): string | null => {
  if (typeof marketErrors === 'string') return marketErrors
  if (!marketErrors || typeof marketErrors !== 'object') return null

  const { domain, category, message, longMessage } = marketErrors

  if (domain === 'MICROSERVICE_ERROR' && PARAM_ERROR_CATEGORIES.includes(category) && typeof message === 'string') {
    return message
  }

  const values = Object.values(marketErrors)
  const label = longMessageLabel(longMessage ?? values[values.length - 1])
  if (label) return label

  return typeof message === 'string' && message ? message : null
}
